export const meta = {
  id: "FW-11",
  name: "Silhouette Nine",
  slug: "silhouette-nine",
  title: "Silhouette Nine — a Fable World: fashion launch page",
  description:
    "An original fashion landing page designed by Fable: split-scroll editorial, a particle-text hero in three.js, monochrome with blood red."
} as const;

export default meta;
